import React, { useContext } from "react"
import classnames from "classnames"
import { FaExclamationTriangle } from "react-icons/fa"

import HeroWrapper from "../HeroWrapper"

import { ThemeContext } from "../layout"
import { FlappyLogo } from "./FlappyLogo"
import { KvellLogo } from "./KvellLogo"

import algoviz from "../../images/algoviz.svg"
import headlines from "../../images/headlines.svg"
import dashboard from "../../images/dashboard.svg"
import panorama from "../../images/panorama.svg"
import kvellExamples from "../../images/kvell-examples.svg"
import devcampBackend from "../../images/devcamps_backend.svg"
// import flappyBird from "../../images/flappyBird.png"

function ProjectItem({
  href,
  className,
  title,
  image,
  imageComponent,
  description,
}) {
  const ItemImage = imageComponent
  return (
    <div className="box project-link">
      <a
        href={href}
        target="_blank"
        rel="noopener noreferrer"
        className={classnames("tile is-child notification", className)}
      >
        <div className="content">
          <p className="title">{title}</p>
          {/* <p className="subtitle">With even more content</p> */}
          {image?.show && (
            <figure className="image is-5by4">
              <img src={image.src} alt={image.alt} />
            </figure>
          )}
          {ItemImage && <ItemImage />}
          <div className="content">{description}</div>
        </div>
      </a>
    </div>
  )
}

function Projects(props) {
  const theme = useContext(ThemeContext)
  return (
    <HeroWrapper id="projects" theme={theme}>
      <div className="hero-body">
        <div className="container">
          <h1 className="title is-2">Projects</h1>
          <div className="tile is-ancestor projects-container">
            <div className="tile is-parent is-vertical pro-col-1">
              <ProjectItem
                href="https://kvelljs.now.sh"
                className="is-warning"
                title="Kvell.js"
                // image={{
                //   show: true,
                //   src: "",
                //   alt: "kvelljs logo",
                // }}
                imageComponent={KvellLogo}
                description={
                  <>
                    Kvell.js is a family of packages using which you can create
                    Node.js applications with pre-defined configurations, a
                    fixed application flow and a set of abstractions. It
                    bootstraps node applications with popularly used packages
                    and provides an environment for the developer to focus on
                    writing the essential parts of the application.
                  </>
                }
              />
              <ProjectItem
                href="https://nsharma1396.github.io/panorama"
                className="is-primary"
                title="Panorama"
                image={{
                  show: true,
                  src: panorama,
                  alt: "panorama virtual reality",
                }}
                description={
                  <>
                    A React based gallery of 360<sup>o</sup> images. Combines
                    the goodness of react and the virtual reality using
                    aframe-react. You can select an image from a collection of
                    panoramic image and view it in virtual reality.
                  </>
                }
              />
            </div>
            <div className="tile is-parent is-vertical pro-col-2">
              <ProjectItem
                href="https://nsharma1396.github.io/chartdashboard/"
                className="is-info"
                title="Dashboard"
                image={{
                  show: true,
                  src: dashboard,
                  alt: "Dummy CPU Dashboard",
                }}
                description="A CPU metrics vizualizer using randomly generated data. Charts developed using D3 and React."
              />
              {/* <ProjectItem
                href="https://algoviz.now.sh/"
                className="is-danger"
                image={{
                  show: true,
                  src: algoviz,
                  alt: "Algorithms Vizualizer",
                }}
                title="Algorithms Vizualizer"
                description={
                  <>
                    <div>
                      <b>
                        <span
                          className="icon wip-icon"
                          title="Work in progress"
                        >
                          <FaExclamationTriangle />
                        </span>
                        [Work in progress]
                      </b>
                    </div>
                    A visualization application built using the power of React
                    and D3.js which makes learning the foundational algorithms
                    of Computer Science fun and interactive.
                  </>
                }
              /> */}
              <ProjectItem
                href="https://github.com/nsharma1396/devcamper"
                className="is-danger"
                image={{
                  show: true,
                  alt: "Dev Bootcamps",
                  src: devcampBackend,
                }}
                title="Dev Bootcamps"
                description={
                  <>
                    Backend for a bootcamp directory website built using
                    Kvell.js. Developed using Restful APIs with MongoDB as the
                    database.
                  </>
                }
              />

              <ProjectItem
                href="https://github.com/nsharma1396/blogs-node-ci" // "https://kvelljs-examples.now.sh/"
                className="is-info"
                title="Node Blogs" // "Kvell.js Examples"
                image={{
                  show: true,
                  src: kvellExamples,
                  // "https://nsharma1396.github.io/react-news-api/static/media/news-icon.d08f12af.png",
                  alt: "Node Blogs", // "Kvell.js Examples",
                }}
                description={
                  <>
                    A MERN based Blog application with the following
                    stack/features:
                    <br />
                    - Caching using Redis.
                    <br />
                    - Automated tests using Jest + Puppeteer.
                    <br />
                    - CI pipeline setup using TravisCI.
                    <br />
                    - Scalable image and file upload using AWS S3.
                    <br />
                  </>
                }
              />
              {/* <ProjectItem
                href="https://kvelljs-examples.now.sh/"
                className="is-info"
                title="Kvell.js Examples"
                image={{
                  show: true,
                  src: kvellExamples,
                  // "https://nsharma1396.github.io/react-news-api/static/media/news-icon.d08f12af.png",
                  alt: "Kvell.js Examples",
                }}
                description={
                  <>
                    <div>
                      <b>
                        <span
                          className="icon wip-icon"
                          title="Work in progress"
                        >
                          <FaExclamationTriangle />
                        </span>
                        [Work in progress]
                      </b>
                    </div>
                    A collection of Node.js applications developed using
                    Kvell.js. Designed to help understand how to utilize kvell
                    in your workflow to make applications with features ranging
                    from basic operations to real time operations.
                  </>
                }
              /> */}
            </div>
            <div className="tile is-parent is-vertical pro-col-3">
              <ProjectItem
                href="https://nsharma1396.github.io/react-news-api/"
                className="is-primary"
                title="Headlines Today"
                image={{
                  show: true,
                  src: headlines,
                  // "https://nsharma1396.github.io/react-news-api/static/media/news-icon.d08f12af.png",
                  alt: "headlines-today logo",
                }}
                description={
                  <>
                    Get access to top trending news across several countries
                    filtered by various news categories using Headlines today.
                    Built on React combined with NewsAPI, it gives you a simple
                    interface to know what's happening around the world so that
                    you stay updated.
                  </>
                }
              />
              <ProjectItem
                href="https://flappybird.now.sh/"
                className="is-warning"
                // image={{
                //   show: true,
                //   src: flappyBird,
                //   alt: "flappy bird",
                // }}
                imageComponent={FlappyLogo}
                title="Flappy Bird"
                description={
                  <>
                    <div>
                      <b>
                        <span
                          className="icon wip-icon"
                          title="Work in progress"
                        >
                          <FaExclamationTriangle />
                        </span>
                        [Work in progress]
                      </b>
                    </div>
                    A clone of the popular flappy bird game in vanilla
                    javascript - My introduction to game development with JS.
                    The game is a side-scroller where the player controls a
                    bird, attempting to fly between columns of green pipes
                    without hitting them.
                  </>
                }
              />
            </div>
          </div>
        </div>
      </div>
    </HeroWrapper>
  )
}

export default Projects
